

import React from 'react'
import toJS from '../hoc/toJS.jsx'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { useFilteredMovies } from '../PageOverview/useFilteredMovies'
import { FRONT, PROGRAM_MOVIES, ROUTESDATA, TRANSLATION } from '../constants/state'
import PageAccessWrapper from '../Accessibility/Page/PageAccessWrapper.jsx'
import getData from '../functions/getData.js'
import OverviewAccess from './OverviewAccess.jsx'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    movies: getData(state, PROGRAM_MOVIES),
    routesData: getData(state, ROUTESDATA),
    translation: getData(state, TRANSLATION),
})

const OverviewFilteredMoviesAccess = ({
    cinemaDataFront,
    movies,
    routesData,
    location,
    translation,

}) => {    
    const { timezone } = translation //???

    const {
        overview_filter_movies_with_attribute,
        hide_no_performance_movies
    } = cinemaDataFront

    const filteredMovies = useFilteredMovies(
        overview_filter_movies_with_attribute,
        hide_no_performance_movies,
        movies,
        timezone
    )

    return (
        <PageAccessWrapper>
            {filteredMovies && filteredMovies.items && <OverviewAccess
                movies={filteredMovies.items}
                moviesOrder={filteredMovies.order} 
                routesData={routesData}
                location={location}
                translation={translation}
                cinemaDataFront={cinemaDataFront}
            />}
        </PageAccessWrapper>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(OverviewFilteredMoviesAccess)